import React, { useState } from 'react';

const Hero = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();
  
  try {
    const response = await fetch('https://formspree.io/f/xvgjyagb', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 
        email: email,
        source: 'Same Flight Friends Waitlist'
      })
    });
    
    if (response.ok) {
      setSubmitted(true);
      setEmail('');
      setTimeout(() => setSubmitted(false), 3000);
    }
  } catch (error) {
    console.error('Error submitting email:', error);
    alert('Something went wrong. Please try again.');
  }
};

  return (
    <div className="relative min-h-screen flex items-center">
      {/* Video Background */}
      <div className="absolute inset-0 overflow-hidden">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute min-w-full min-h-full object-cover"
        >
          <source src="/Videos/airport-help.mp4" type="video/mp4" />
          {/* Fallback to image if video doesn't load */}
        </video>
        
        {/* Dark overlay for text readability */}
        {/* <div className="absolute inset-0 bg-gradient-to-br from-blue-900/80 to-indigo-900/80"></div> */}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/40 to-indigo-900/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 py-20 md:py-32">
        <div className="max-w-4xl mx-auto text-center text-white">
          <div className="mb-8">
            <div className="text-2xl md:text-3xl font-semibold text-blue-200 mb-4">
              Same Flight Friends
            </div>
            <h1 className="text-4xl md:text-6xl font-bold drop-shadow-lg">
              ✈️ Never Let Your Parents Travel Alone Again
            </h1>
          </div>
          <p className="text-xl md:text-2xl mb-8 text-blue-100 drop-shadow-md">
            Connect with helpful co-passengers on the same flight who speak their language
          </p>
          
          {/* Email Signup Form */}
          <div className="max-w-md mx-auto">
            {submitted ? (
              <div className="bg-green-500 text-white px-6 py-4 rounded-lg font-semibold shadow-lg">
                ✓ Thanks! We'll notify you when we launch.
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                  className="flex-1 px-4 py-3 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-300 shadow-lg"
                />
                <button
                  type="submit"
                  className="bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-semibold px-8 py-3 rounded-lg transition shadow-lg hover:shadow-xl"
                >
                  Join Waitlist
                </button>
              </form>
            )}
            <p className="text-sm text-blue-200 mt-3 drop-shadow">
              Get early access when we launch in early 2026
            </p>
          </div>

          {/* Trust indicators */}
          <div className="mt-12 flex flex-wrap justify-center gap-8 text-sm text-blue-100">
            {/* <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
              <span className="text-2xl">🔒</span>
              <span>Secure Payments</span>
            </div> */}
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
              <span className="text-2xl">⭐</span>
              <span>Verified Helpers</span>
            </div>
            <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
              <span className="text-2xl">✈️</span>
              <span>Same Flight Guarantee</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;